import { createSlice } from '@reduxjs/toolkit';
import { make_generic_proxy_url } from './utils.js';

// api client
import apiClient from './apiClient.js'

const REQUESTS = {
  index: (id) => {
    return `query {
      potreeLayer(id: "${id}"){
        id,
        name,
        metadataUrl,
        projectUrl
      }
    }`   
  },
  create: ({ name, missionId, metadataUrl, projectUrl = '' }, outputFields = `id,name,missionId,metadataUrl,projectUrl`) => {
    return `mutation {
      createPotreeLayer(potreeLayer: {
        name: "${name}",
        missionId: "${missionId}",
        metadataUrl: "${metadataUrl}",
        projectUrl: "${projectUrl}"
      }){
        ${outputFields}
      }
    }`
  },
  delete: (id) => {
    return `mutation { deletePotreeLayer(id: "${id}") }`
  },
}


export const potreeLayerApi = {
  get: async (id, next) => {
    const result = await apiClient.req(REQUESTS.index(id))
    next(result.data.data.potreeLayer)
  },
  create: async ({ name, missionId, metadataUrl, projectUrl = '' }) => {
    const result = await apiClient.req(
      REQUESTS.create({ name, missionId, metadataUrl, projectUrl })
    )
    if (result.data?.errors?.length) {
      throw new Error(result.data.errors[0]?.message || 'createPotreeLayer failed')
    }
    return result.data?.data?.createPotreeLayer
  },
  delete: async (id) => {
    const result = await apiClient.req(REQUESTS.delete(id))
    return result.data?.data?.deletePotreeLayer
  },
}

/** Proxy URL for a Potree file. */
export function potreeLayerContentUrl(baseUri, authToken, potreeLayerId) {
  return make_generic_proxy_url(baseUri, 'parent_folder', authToken, { potreeLayerId });
}

/** True when projectUrl is a non-empty Potree project file URI (not a folder). */
export function isPotreeProjectFileUrl(uri) {
  if (uri == null || typeof uri !== 'string') return false;
  const trimmed = uri.trim();
  if (!trimmed) return false; // present but empty (backend required field)
  const path = trimmed.split('?')[0];
  if (path.endsWith('/')) return false;
  return /\.(json5?|js)$/i.test(path);
}

const initialState = {
  ready: false
}


export const potreeSlice = createSlice({
  name: 'potree',
  initialState,
  reducers: {
    setPotreeLayer: (state, {payload: {potreeLayer}}) => {
      return {
        ...state,
        potreeLayer
      }
    },
    setReady: (state, {payload:{ready}}) => {
      return {
        ...state,
        ready
      }
    }
  }
});

export const { setPotreeLayer, setReady } = potreeSlice.actions;

export const selectPotreeLayer = (state) => state.potree.potreeLayer
export const selectReady = (state) => state.potree.ready

export default potreeSlice.reducer;
